export const degreesToRadians = degrees => degrees * (Math.PI / 180);

